:host {
  padding: 16px 32px;
  border-bottom-left-radius: var(--Common--border-radius);
  border-bottom-right-radius: var(--Common--border-radius);
  background: var(--theme-secondary-background);
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

:host(:has([slot="footer_text"])) .footer__actions {
  margin-left: unset;
}

.footer {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}

.footer__actions {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.footer__text:not([hidden]) {
  margin-left: auto;

  & ~ .footer__actions {
    margin-left: unset;
  }
}

slot::slotted(*:not(:last-child)) {
  margin-right: 5px;
}
.footer__actions > *:not(:last-child) {
  margin-right: 50px;
}

slot[name="footer_text"]::slotted(*) {
  color: var(--theme-tertiary-text);
  margin-left: auto;
  margin-right: var(--spacer-7);
}
